import { defineMessages } from "react-intl";

export default defineMessages({
  won: {
    id: "TeamSummaryCard.won",
    defaultMessage: "won"
  },
  drawn: {
    id: "TeamSummaryCard.drawn",
    defaultMessage: "drawn"
  },
  lost: {
    id: "TeamSummaryCard.lost",
    defaultMessage: "lost"
  },
  players: {
    id: "TeamSummaryCard.players",
    defaultMessage: "players"
  },
  totalMatches: {
    id: "TeamSummaryCard.totalMatches",
    defaultMessage: "Total matches"
  },
  league: {
    id: "TeamSummaryCard.league",
    defaultMessage: "League"
  },
  noLeague: {
    id: "TeamSummaryCard.noLeague",
    defaultMessage: "no league included yet"
  },
  matchesLabel: {
    id: "TeamSummaryCard.matchesLabel",
    defaultMessage: "Matches"
  },
  noMatchesPlayed: {
    id: "TeamSummaryCard.noMatchesPlayed",
    defaultMessage: "No matches played yet"
  },
  nextTraining: {
    id: "TeamSummaryCard.nextTraining",
    defaultMessage: "Next training"
  },
  noTrainingSet: {
    id: "TeamSummaryCard.noTrainingSet",
    defaultMessage: "No training set"
  },
  wonAbbr: {
    id: "TeamSummaryCard.wonAbbr",
    defaultMessage: "W"
  },
  drawnAbbr: {
    id: "TeamSummaryCard.drawnAbbr",
    defaultMessage: "D"
  },
  lostAbbr: {
    id: "TeamSummaryCard.lostAbbr",
    defaultMessage: "L"
  }
});
